import environment from "~libs/environment";
import {
  errorUnlessOk,
  buildRequestWithAuth,
  headersBackendSeguros,
} from "./utils";

/**
 * El contrato del backend declara para /roles un IReturn de GetUsuariosResponse
 * que no se corresponde con lo que devuelve: la respuesta real trae items.
 */
export interface GetRolesResponse {
  items: string[];
}

const roles = () => {
  return {
    getRoles: (): Promise<GetRolesResponse> => {
      const request = buildRequestWithAuth("GET", null, headersBackendSeguros);
      const url = environment.segurosUrl + "/roles";

      return fetch(url, request)
        .then(errorUnlessOk)
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
  };
};

export { roles };
